import Logo from "./Logo";
import Menu from "./Menu";
import MobileBurger from "./MobileBurger";
import LogoutButton from "./LogoutButton";
import { useContext } from "react";
import { UserContext } from "../../contexts/userContext";
import '../../styles/mobile-menu.css';
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Header({role}) {
  const [ open, setOpen ] = useState(false);
    const { logOutUser } = useContext(UserContext);
    const location = useLocation();

    useEffect(() => {
      setOpen(false);
    }, [location]);
    const logOut = async () => {
        try {
          const loggedOut = await logOutUser();
          if (loggedOut) {
            window.location.reload(true);
          }
        } catch (error) {
          alert(error)
        }
    };
    return (
      <>
        <header>
            <Logo/>
            <MobileBurger open={open} setOpen={setOpen}/>
            <Menu role={role}/>
            <LogoutButton logOut={logOut}/>
        </header>
        { open && <div className="mobile-menu">
            <Menu role={role}/>
            <LogoutButton logOut={logOut}/>
        </div> }
      </>
    )
}